export const formatDateAndTime = (isoString) => {
    const date = new Date(isoString);
    
    // Changed locale from "en-GB" to "en-US" for mm/dd/yyyy format
    const formattedDate = date.toLocaleDateString("en-US", { timeZone: 'UTC' });
    
    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
      timeZone: 'UTC'
    });
  
    return { formattedDate, formattedTime };
  };
  